<template>
  <div class="home">
    <div class="search">
      <div class="block">
        <span>选择查询时间</span>
        <el-date-picker
          v-model="date"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          align="right"
          :clearable="false"
        >
        </el-date-picker>
        <el-button type="primary" @click="submit" icon="el-icon-search">查询</el-button>
      </div>
    </div>
    <el-table :data="tableData" empty-text="暂无数据" max-height="72vh">
      <el-table-column prop="parkId" label="所属车场"> </el-table-column>
      <el-table-column prop="shopName" label="商家名称"> </el-table-column>
      <el-table-column prop="type" label="类型"></el-table-column>
      <el-table-column prop="needCharge" label="应收"> </el-table-column>
      <el-table-column prop="discount" label="折扣"> </el-table-column>
      <el-table-column prop="actualCharge" label="实收"> </el-table-column>
      <el-table-column prop="admin" label="操作员"> </el-table-column>
      <el-table-column prop="createTime" label="充值时间"> </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="limit"
        layout="sizes, prev, pager, next"
        :total="count"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { util } from "../utils/global"
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近1小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              var start = date.setHours(0, 0, 0, 0);
              var end = date.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const oDate = new Date();
              var year = oDate.getFullYear();
              var month = oDate.getMonth() + 1;
              var start, end;
              if (month == 0) {
                year--;
                start = new Date(year, 11, 1);
                end = new Date(year, 11, 31);
              } else {
                start = new Date(year, month - 1, 1);
                end = new Date(year, month, 0);
              }
              end.setTime(end.setHours(23, 59, 59, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上个月",
            onClick(picker) {
              const oDate = new Date();
              var year = oDate.getFullYear();
              var month = oDate.getMonth();
              var start, end;
              if (month == 0) {
                year--;
                start = new Date(year, 11, 1);
                end = new Date(year, 11, 31);
              } else {
                start = new Date(year, month - 1, 1);
                end = new Date(year, month, 0);
              }
              end.setTime(end.setHours(23, 59, 59, 0));
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      date: [new Date().setHours(0, 0, 0, 0), new Date()],
      tableData: [],
      page: 1,
      limit: 20,
      count: 0,
      shopId: "",
      parkId:"",
    };
  },
  mounted() {
    let data = JSON.parse(sessionStorage.getItem("shopData"));
    this.shopId = data.shop.id;
    this.parkId = data.shop.parkId;
    this.submit();
  },
  methods: {
    submit() {
      let data = {
        // 商家ID
        shopId: this.shopId,
        // 开始时间
        timeStart: this.dates(new Date(this.date[0])),
        // 结束时间
        timeEnd: this.dates(new Date(this.date[1])),
        // 请求数据参数
        page: this.page,
        limit: this.limit,
        parkId:this.parkId
      };
      this.$axios
        .post("shopCharge/list", data)
        .then((res) => {
          if(res.code == 0){
            this.tableData = res.data;
            this.count = res.count
            if(res.data.length == 0){
              util.hint(2,"暂无数据")
            }
          }else {
            util.hint(res.code,res.msg);
          };
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    dates(date) {
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },

    // 当每页显示的数据条数发发生改变时（pageSize），触发此方法
    handleSizeChange(pageSize) {
      this.limit = pageSize;
      this.submit();
    },
    // 当前页面显示的页码发生改变时（pageIndex），触发此方法
    // 用户点击页码或者上一页 下一页的按钮时，都会使pageIndex发生改变
    handleCurrentChange(pageIndex) {
      this.page = pageIndex;
      this.submit();
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 0.1rem;
  box-sizing: border-box;

  .el-table {
    border: 1px solid #ebeef5;
    overflow-y: scroll;

    /deep/ th {
      padding: 0;
      height: 50px;
      line-height: 50px;
    }
  }

  .block {
    height: 1rem;
    padding: 0.2rem;
    box-sizing: border-box;
    text-align: left;
    line-height: normal;

    .plate {
      display: inline-block;
      .el-input {
        width: 80%;
      }
    }
    span {
      display: inline-block;
      height: 0.4rem;
      line-height: 0.4rem;
      vertical-align: middle;
      padding: 3px 10px;
    }
  }

  .paging {
    text-align: center;
    padding: 0.2rem;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/topUpDetail.vue